module.exports = __webpack_public_path__ + "static/mobileHero-6031572f820b631aaca77e3591ea1fc5.png";